<template>
    <a-modal
      :title="$t('appointment-actions.reschedule')"
      :visible="visible"
      :closable="false"
      okText="Yes"
      cancelText="No"
      :confirm-loading="isLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      
        
        <appointment-summary :appointment="appointment" />

        <h6 style="margin-top: 10px;">{{ $t('appointment-fields.previous-schedule')}}: {{ previousDate }}</h6>
        <h6 style="margin-top: 10px;">{{ $t('appointment-fields.new-schedule')}}</h6>

        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
            <a-date-picker 
                size="small" 
                v-model="selectedDate" 
                format="DD MMM, yyyy" 
                @change="onDateSelected"
                :disabledDate="current => current && current < moment()"
            />
        </div>

        <a-spin :spinning="isLoading" size="large">
            <div class="spin-content">
                <h6>{{ $t('appointment-timeline.free-slot') }}</h6>
                <div style="min-height: 170px; width:  500px; display: flex; align-items: center; justify-content: center; flex-wrap: wrap;">
                    <a-radio-group button-style="solid" @change="onSlotSelected">
                        <a-radio-button :value="i" v-for="(timeline, i) in ranges" :key="i">
                            {{ timeline.time }}
                        </a-radio-button>
                    </a-radio-group>
                </div>
            </div>
        </a-spin>

        
        



        <a-form-item class="mt-20 approve-duration-form-item">	
            <a-form-item label="Probable Duration" >
                <a-select
                    style="width: 100%;"
                    v-model="duration"
                    class="form-input"
                    show-search
                    placeholder="Select appointment type"
                    option-filter-prop="children">
                    <a-select-option value="15">
                        15 Mins
                    </a-select-option>
                    <a-select-option value="30">
                        30 Mins
                    </a-select-option>
                    <a-select-option value="45">
                        45 Mins
                    </a-select-option>
                    <a-select-option value="60">
                        60 Mins
                    </a-select-option>
                    <a-select-option value="75">
                        1 Hour 15 Mins
                    </a-select-option>
                    <a-select-option value="90">
                        1 Hour 30 Mins
                    </a-select-option>
                    <a-select-option value="105">
                        1 Hour 45 Mins
                    </a-select-option>
                    <a-select-option value="120">
                        2 Hours
                    </a-select-option>
                    <a-select-option value="135">
                        2 Hours 15 Mins
                    </a-select-option>
                    <a-select-option value="150">
                        2 Hours 30 Mins
                    </a-select-option>
                    <a-select-option value="165">
                        2 Hours 45 Mins
                    </a-select-option>
                    <a-select-option value="180">
                        3 Hours
                    </a-select-option>
                    <a-select-option value="195">
                        3 Hour 15 Mins
                    </a-select-option>
                    <a-select-option value="210">
                        3 Hour 30 Mins
                    </a-select-option>
                    <a-select-option value="225">
                        3 Hour 45 Mins
                    </a-select-option>
                    <a-select-option value="240">
                        4 Hours
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-form-item>

        <a-form-item v-show="type == 'ONLINE'" class="mb-5">	
            <a-form-item label="Meeting Link" >
                <a-input
                    style="margin-left: 5px;"
                    class="form-input"
                    placeholder="Meeting Link (Zoom, Cisco Webex, Google Meet)"
                    v-model="meetingLink"
                />
            </a-form-item>
        </a-form-item>
        
        
        
    </a-modal>
</template>
<script>

import { useAppointmentsStore } from '../../../../stores/appointments-store';
import { mapActions, mapState } from 'pinia';
import { toastMixin } from '../../../../mixins/ToastMixin';
import moment from 'moment';
import AppointmentSummary from '../../items/AppointmentSummary.vue';

export default {
    props: {
        hour: {
            type: Number,
            required: true,
        },
        min: {
            type: Number,
            required: true,
        },
        date: {
            type: String,
            required: true
        }
    },
    components: {
        AppointmentSummary
    },
    mixins: [ toastMixin ],
    data() {
        return {
            title: 'Are You Sure You Want to Approve this appointment ?',
            isLoading: false,
            visible: false,
            duration: '15',
            meetingLink: '',
            appointment: null,
            selectedDate: moment(),
            moment: moment,
            officialId: '',
            ranges: [],
            isLoading: false,
            selectedSlotIndex: -1
        }
    },
    computed: {
        ...mapState(useAppointmentsStore, { 
            'item': 'selectedAppointment', 
            'selectedOfficial': 'selectedOfficialForReview' 
        }),
        type() {
            if (this.appointment && this.appointment.type)
                return this.appointment.type;
            return '';
        },
        previousDate() {
            if (this.appointment) {
                return this.$d(new Date(this.appointment.dateTs), 'short');
            }
            return '';
        }
    },
    methods: {
        ...mapActions(useAppointmentsStore, [ 'rescheduleAppointment', 'findFreeSlotOfDate' ]),
        onSlotSelected(e) {
            this.selectedSlotIndex = e.target.value;

        },
        handleOk() {
            if (this.selectedSlotIndex < 0) {
                this.errorToast(this.$t('toast-error-messages.select-valid-slot'));
                return;
            }
            
            this.isLoading = true;
            this.rescheduleAppointment(this.appointment, this.selectedDate.format('YYYY-MM-DD'), Number(this.duration), this.ranges[this.selectedSlotIndex].hour, this.ranges[this.selectedSlotIndex].min, this.meetingLink).then(res => {
                this.$emit('success', this.appointment.id);    
                this.visible = false;
                this.isLoading = false;
            }).catch(error => {
                if (error == 'network_error') {
                    this.errorToast(this.$t('toast-error-messages.network-error'));
                } else {
                    this.errorToast(this.$t('toast-error-messages.error') + error);
                }
                this.isLoading = false;
            });
            // this.$emit('success', this.appointment.id);
            // this.approveSelectedAppointment(this.hour, this.min, this.date, Number(this.duration));
            // this.visible = false;
            // this.isLoading = true;
            // let data = { id: this.item.id, hour: this.hour, min: this.min, date: this.date, durationInMins: Number(this.duration), meetingLink: this.meetingLink };
            // appointmentsClient.approveAppoinment(data).then(res => {
            //     if (!res.networkError) {
            //         if (res.status == 202) {
            //             this.approveSelectedAppointment(this.hour, this.min, this.date, Number(this.duration));
            //             this.visible = false;
            //             this.successToast('Successfully approved Appointment');    
            //             this.$emit('success', this.item.id);
            //         } else {
            //             this.errorToast('Error approving Appointment, status code :: ' + res.status);    
            //         }
            //     } else {
            //         this.errorToast('Network Error, Could not approve Appointment, please check network connection');    
            //     }
                
            //     this.isLoading = false;
            // });
        },
        handleCancel() {
            this.visible = false;
        },
        showModal(apt) {
            this.appointment = apt;
            this.visible = true;
            console.log('officialId :: ' + apt.officialId);
            this.fetchRanges();
        },
        onDateSelected() {
            this.fetchRanges();
        },
        fetchRanges() {
            this.isLoading = true;
            this.findFreeSlotOfDate(this.appointment.officialId, this.selectedDate.format('YYYY-MM-DD')).then(ranges => {
                this.ranges = ranges;       
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        }

    },
    
}
</script>
